import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from './redux/slices/login';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import {themeGeorgia, themeOther} from './theme/theme';
import reportWebVitals from './reportWebVitals';
import SpinnerStatic from "./components/common/Spinner";

const themeF = process.env.REACT_APP_City === 'GA' ? themeGeorgia : themeOther;
const root = ReactDOM.createRoot(document.getElementById('root'));


const initApp = async () => {
  await import('./i18n');
  const { default: App } = await import('./App');
  
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={themeF}>
        <Provider store={store}>
          <Suspense fallback={<SpinnerStatic />}>
            <App />
          </Suspense>
        </Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

root.render(<SpinnerStatic />);

initApp();

reportWebVitals();